import qs from 'qs';
import sessionStorageUtils from 'utils/sessionStorageUtils';

const KEYCLOAK_AUTH_FLOW = 'keycloak';
const IDA_AUTH_FLOW = 'ida';

export const AUTH_FLOW_KEY = 'authFlow';

const resolveFlow = () => {
  const storedFlow = sessionStorageUtils.get(AUTH_FLOW_KEY);

  if (storedFlow === KEYCLOAK_AUTH_FLOW || storedFlow === IDA_AUTH_FLOW) {
    return storedFlow;
  }

  const { flow: flowName } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  const flow = flowName === KEYCLOAK_AUTH_FLOW ? KEYCLOAK_AUTH_FLOW : IDA_AUTH_FLOW;

  sessionStorageUtils.set(AUTH_FLOW_KEY, flow);

  return flow;
};

const flow = resolveFlow();

const userAuthManager =
  flow === KEYCLOAK_AUTH_FLOW
    ? require('utils/keycloakUserManager').default
    : require('utils/userManager').default;

export default userAuthManager;
